<div class="container g-0 m-0">
  <div class="row row g-0 m-0">
    <h2 class="title">{{ "CRUD_TITLE" | translate }}</h2>
    <p class="subtitle">{{ "CRUD_SUBTITLE" | translate }}</p>
  </div>
  <div class="row g-0 m-0">
    <ul>
      @if(authService.isAuthorized([PermissionsEnum.Settings_crud_region_view])){
        <li
          (click)="navigate('settings/crud/region')"
          [class.active]="isActive('settings/crud/region')"
        >
          {{ "DEVICESETUP_REGION" | translate }}
        </li>
      }
      @if(authService.isAuthorized([PermissionsEnum.Settings_crud_area_view])){
        <li
          (click)="navigate('settings/crud/area')"
          [class.active]="isActive('settings/crud/area')"
        >
          {{ "DEVICESETUP_AREA" | translate }}
        </li>
      }
      @if(authService.isAuthorized([PermissionsEnum.Settings_crud_servicetype_view])){
        <li
          (click)="navigate('settings/crud/service-type')"
          [class.active]="isActive('settings/crud/service-type')"
        >
          {{ "DEVICESETUP_SERVICETYPE" | translate }}
        </li>
      }
      @if(authService.isAuthorized([PermissionsEnum.Settings_crud_metermake_view])){
        <li
          (click)="navigate('settings/crud/meter-make')"
          [class.active]="isActive('settings/crud/meter-make')"
        >
          {{ "DEVICESETUP_METERMAKE" | translate }}
        </li>
      }
      @if(authService.isAuthorized([PermissionsEnum.Settings_crud_metermodel_view])){
        <li
          (click)="navigate('settings/crud/meter-model')"
          [class.active]="isActive('settings/crud/meter-model')"
        >
          {{ "DEVICESETUP_METERMODEL" | translate }}
        </li>
      }
      @if(authService.isAuthorized([PermissionsEnum.Settings_crud_assettype_view])){
        <li
          (click)="navigate('settings/crud/asset-type')"
          [class.active]="isActive('settings/crud/asset-type')"
        >
          {{ "DEVICESETUP_ASSETTYPE" | translate }}
        </li>
      }
    </ul>
  </div>
  <div class="row g-0 m-0">
    <router-outlet></router-outlet>
  </div>
</div>
